module.exports = __webpack_public_path__ + "img/advantage_icon_security.b0fe5697.svg";